<template>
	<div class="rowNewSection">
		<RowSectionForm class="rowNewSection-form" v-if="isEdit" @submit="submit" :data="data"></RowSectionForm>
		<div class="rowNewSection-holder" v-else @click="isEdit = true">
			<div class="rowNewSection-icon"></div>
			<div class="rowNewSection-text">
				Добавить дополнительную секцию
			</div>
		</div>
	</div>
</template>

<script>
	import RowSectionForm from './RowSectionForm';

	export default {
		props: {
			data: Object,
		},
		data() {
			return {
				isEdit: false,
			};
		},
		methods: {
			submit(data) {
				this.$emit('submit', data);
				this.isEdit = false;
			},
		},
		components: {
			RowSectionForm
		},
	};
</script>

<style scoped>
	.rowNewSection {
		display: flex;
		flex-direction: column;
		/* align-items: center; */
		justify-content: center;
		padding: 16px 24px 32px;
		width: 228px;
		background: #F6F6F6;
		cursor: pointer;
	}
	.rowNewSection-form {
		flex: 1;
		margin-top: 41px;
	}
	.rowNewSection-holder {
		text-align: center;
	}
	.rowNewSection-icon {
		display: inline-block;
		margin-bottom: 15px;
		width: 50px;
		height: 50px;
		background: #F58214 url(../../public/icons/sign.svg) no-repeat center center;
	}
	.rowNewSection-text {
		font-size: 14px;
		line-height: 16px;
	}
</style>